import React from 'react';

const Download = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 13 16" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Download_a" d="M1172.17 97v6.35H1169l6.35 6.35 6.35-6.35h-3.18V97z" />
      <path id="Download_b" d="M1169 112.9h12.7v-1.82H1169z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Download_a" transform="translate(-1169 -97)" />
    <use fill="currentColor" xlinkHref="#Download_b" transform="translate(-1169 -97)" />
  </svg>
);

export default Download;



// WEBPACK FOOTER //
// ./src/common/icons/Download.js